import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { stripeCheckout, stripeSubscription } from "../../../../api/purchases";
import { alertError } from "../../../../utils";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { checkIfUserExistsByToken } from "../../../../api/user";

function priorityA(a, b) {
  const intA = a.recurring.interval, intB = b.recurring.interval;
  const countA = a.recurring.interval_count, countB = b.recurring.interval_count;
  if (intA === "day") return true;
  if (intB === "day") return false;
  if (intA === "month" && intB === "month") {
    if (countB > countA) return true;
    return false;
  }
  if (intA === "month") return true;
  return false;
}

function sortByInterval(a, b) {
  if (priorityA(a, b)) return -1;
  return 1;
}

export function PaymentPage() {
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");
  const isVisit = query.get("visit");
  const idProd = query.get("idProd"); //Only for visit

  const [subscriptions, setSubscriptions] = useState([]);
  const [exists, setExists] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    if (token) {
      setLoading(true);
      if (!isVisit)
        stripeSubscription()
          .then((res) => {
            let newSubscriptions = res.data;
            for (let i = 0; i < newSubscriptions.length; ++i) {
              const actS = newSubscriptions[i];
              let dataPrices = actS.prices;
              dataPrices.sort(sortByInterval);
              newSubscriptions[i].prices = dataPrices;
            }
            newSubscriptions.reverse()
            
            setSubscriptions(newSubscriptions);
          })
          .catch((error) => {
            alertError({ error, customMessage: "Could not obtain subscriptions"});
          })

      // redirectToCheckout();
      checkIfUserExistsByToken(token)
        .then((res) => {
          setExists(true);
          setLoading(false);
          if (isVisit) {
            redirectToCheckout(idProd);
          }
        })
        .catch((error) => {
          setExists(false);
          setLoading(false);
        })
    }
  }, []);
  
  const redirectToCheckout = async (price) => {
    const res = await stripeCheckout(token, price, isVisit)
      .catch((error) => {
        alertError({
          error, customMessage: "Ha habido un error al redireccionar al pago."
        })
      })

    const data = await res.data;
    window.location.href = data.url;
  };

  function translateInterval(interval, plural) {
    if (plural) {
      switch (interval) {
        case "year": return "año";
        case "month": return "meses";
        default: return "días";
      }
    }
    else {
      switch (interval) {
        case "year": return "año";
        case "month": return "mes";
        default: return "día";
      }
    }
  }

  const BlockPrice = ({ price }) => {
    const total = (price.unit_amount / 100).toFixed(2);
    const interval = price.recurring.interval;
    const intervalCount = price.recurring.interval_count || 1;

    // Calcular precio mensual estimado si es anual
    const monthlyEquivalent =
      interval === 'year'
        ? (price.unit_amount / 100 / (12 * intervalCount)).toFixed(2)
        : interval === "month" && intervalCount > 1 
        ? (price.unit_amount / 100 / (intervalCount)).toFixed(2)
        : null;
    const translatedInterval = translateInterval(interval, false);
    const translatedIntervalPlural = translateInterval(interval, true);

    return (
      <div style={styles.blockPrice}>
      <h3 style={styles.title}>{total} € / {intervalCount === 1 ? translatedInterval : `${intervalCount} ${translatedIntervalPlural}`}</h3>
      {monthlyEquivalent && (
        <p style={styles.subtitle}>≈ {monthlyEquivalent} €/mes</p>
      )}
      <button style={styles.button} onClick={() => redirectToCheckout(price)}>Seleccionar</button>
    </div>
    );
  };

  function renderSubscriptions() {
    return (
      <>
        { subscriptions.length > 0 && subscriptions.map((x, index) => {
          return (
            <div key={index} style={{ marginBottom: 60}}>
              <p style={{ fontSize: 20, fontWeight: 'bold' }}>{x.name}</p>
              <p style={{ fontSize: 16, fontWeight: 'semibold' }}>{x?.description}</p>
              <div style={styles.priceContainer}>
                { x.prices.map((z, indexx) => {
                  return <BlockPrice key={indexx} price={z}/>
                })}
              </div>
            </div>
          )
        })}
      
      </>
    )
  }

  return (
    <>
    <div className='success-page' style={{ textAlign: 'center', padding: '50px' }}>
      <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '30px', width: '100%' }}>
        <img 
          src={toAbsoluteUrl("/media/logo/logo-complete-black.png")}
          style={{ maxWidth: '250px' }}
          alt="Logo"
        />
      </div>

      {(loading || isVisit) ? (
        <>
          <h2>Cargando...</h2>
        </>
      ) : exists ? (
        <>
          <p style={{ fontWeight: 'bold', fontSize: 24}}>Selecciona que plan quieres</p>
          <br />
          <p></p>
          <div>
            {renderSubscriptions()}
          </div>
        </>
      ) : (
        <>
          <h2>Vaya! Parece que el link ha caducado. Hable con el nutricionista para recibir uno nuevo.</h2>
        </>
      )}
      <br /><br/><br/><br /><br/><br/><br /><br/><br/>
    </div>
    </>
  );
}

const styles = {
  priceContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '24px',
    flexWrap: 'wrap',
    marginTop: '32px',
  },
  blockPrice: {
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    padding: '24px',
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    border: '1px solid #e5e7eb',
    height: 140
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#111827',
    margin: 0,
    alignSelf: 'center'
  },
  subtitle: {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0,
    alignSelf: 'center'
  },
  button: {
    marginTop: 'auto',
    padding: '8px 16px',
    backgroundColor: '#80c139',
    color: 'white',
    borderRadius: '12px',
    border: 'none',
    cursor: 'pointer',
    transition: 'background 0.2s ease',
    alignSelf: 'center'
  }
};
